import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const ScoreFilter = ({ onFilterChange, type = 'discovery' }) => {
  const [distribution, setDistribution] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/offers/score-distribution`);
        setDistribution(res.data);
        const d = type === 'discovery' ? res.data.discovery : res.data.ghost_recon;
        if (d && d.threshold > 0) {
          // Normalize to 0-100 slider
          const maxScore = d.max || 100;
          const normalized = Math.round((d.threshold / maxScore) * 100);
          setSliderValue(normalized);
          if (onFilterChange) onFilterChange(d.threshold);
        }
        setInitialized(true);
      } catch {
        setInitialized(true);
      }
    };
    fetch();
  }, [type]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!initialized || !distribution) return null;

  const d = type === 'discovery' ? distribution.discovery : distribution.ghost_recon;
  const maxScore = d?.max || 100;

  const handleSliderChange = (e) => {
    const val = parseInt(e.target.value);
    setSliderValue(val);
    const actualScore = (val / 100) * maxScore;
    if (onFilterChange) onFilterChange(showAll ? 0 : actualScore);
  };

  const handleShowAllToggle = () => {
    const next = !showAll;
    setShowAll(next);
    if (onFilterChange) {
      onFilterChange(next ? 0 : (sliderValue / 100) * maxScore);
    }
  };

  const currentThreshold = showAll ? 0 : Math.round((sliderValue / 100) * maxScore);

  return (
    <div className="flex items-center gap-3 bg-slate-800/50 rounded-lg px-4 py-2.5 border border-slate-700/50" data-testid="score-filter">
      <span className="text-xs text-slate-400 whitespace-nowrap">Score</span>
      <input
        type="range"
        min="0"
        max="100"
        value={showAll ? 0 : sliderValue}
        onChange={handleSliderChange}
        disabled={showAll}
        className="w-24 h-1.5 accent-emerald-500 cursor-pointer disabled:opacity-40"
        data-testid="score-slider"
      />
      <span className="text-xs text-emerald-400 font-medium w-10 text-right" data-testid="score-threshold-display">
        {showAll ? 'All' : `${currentThreshold}+`}
      </span>
      <button
        onClick={handleShowAllToggle}
        className={`px-2 py-0.5 rounded text-xs transition-colors ${
          showAll
            ? 'bg-emerald-500/20 text-emerald-400'
            : 'bg-slate-700/50 text-slate-400 hover:text-white'
        }`}
        data-testid="show-all-toggle"
      >
        {showAll ? 'Filtered' : 'Show All'}
      </button>
    </div>
  );
};

export default ScoreFilter;
